import icEditPrimary from 'assets/images/ic-edit-04-primary.svg'
import icEyeOpen from 'assets/images/ic-eye-open.svg'
import icFileEye from 'assets/images/ic-file-eye-02.svg'
import icTrash01Red from 'assets/images/ic-trash-01-red.svg'
import Badge from 'components/commons/badge'
import Button from 'components/commons/button'
import { ACTION_TYPE } from 'constants/constant'

export const TABLE_DEVELOPMENT_SUMMARY_LIST = {
    name: 'Data Development Summary',
    column: [
        {
            name: 'Periode',
            key: 'year',
            className: 'font-bold capitalize',
        },
        {
            name: 'Total Karyawan',
            key: 'total_employees',
            className: 'font-bold capitalize',
        },
        {
            name: 'Action',
            key: 'action',
            classNameHeader: '!text-center w-32',
            render: ({ item, onClickItem }) => (
                <Button
                    className='w-[80px] mx-auto'
                    type='outline'
                    icon={icEyeOpen}
                    title='Detail'
                    onClick={() => onClickItem(item.id)}
                />
            ),
        },
    ],
}

export const INITIAL_DATA_QUERY = {
    page: 1,
    limit: 20,
    search: '',
}

export const TABLE_DEVELOPMENT_SUMMARY_DETAIL = {
    name: 'Data Development Summary',
    column: [
        {
            name: 'Nama Karyawan',
            key: 'name',
            classNameHeader: 'sticky left-[70px] z-10 !min-w-[170px]',
            className: 'font-semibold max-w-0 sticky left-[70px] bg-white',
            render: ({ item }) => item?.employee?.full_name,
        },
        {
            name: 'NIP',
            key: 'nip',
            className: 'font-bold capitalize',
            render: ({ item }) => item?.employee?.nip,
        },
        {
            name: 'Job Title Karyawan',
            key: 'job_title',
            className: 'font-bold capitalize',
        },
        {
            name: 'Department',
            key: 'department',
            className: 'font-bold capitalize',
        },
        {
            name: 'Divisi',
            key: 'division',
            className: 'font-bold capitalize',
        },
        {
            name: 'KPI',
            key: 'kpi',
            sortable: true,
            render: ({ value }) => `${value}%`,
        },
        {
            name: 'Attendance',
            key: 'attendance',
            sortable: true,
            render: ({ value }) => `${value}%`,
        },
        {
            name: 'Seminar',
            key: 'seminar',
            sortable: true,
            render: ({ value }) => `${value}%`,
        },
        {
            name: '360 Category',
            key: 'three_sixty_category',
            className: 'min-w-[150px]',
        },
        {
            name: 'User Review',
            key: 'user_review',
        },
        {
            name: 'Performance Category',
            key: 'performance_category',
            className: 'capitalize min-w-[100px]',
        },
        {
            name: 'Psychology Test',
            key: 'psychology_test',
            sortable: true,
        },
        {
            name: 'Potential Category',
            key: 'potential_category',
            className: 'capitalize min-w-[100px]',
        },
        {
            name: '9 Box Label',
            key: 'nine_box_label',
            className: 'min-w-[120px]',
        },
        {
            name: 'Documents',
            key: 'documents',
            render: ({ item, onClickItem }) => (
                <Button
                    className='p-2.5! mx-auto'
                    type='outline'
                    icon={icFileEye}
                    onClick={() => onClickItem({ item, actionType: ACTION_TYPE.PREVIEW })}
                />
            ),
        },
        {
            name: 'Action',
            key: 'action',
            classNameHeader: '!text-center',
            render: ({ item, onClickItem }) => (
                <div className='flex space-x-2 justify-center'>
                    <Button
                        type='outline'
                        icon={icEditPrimary}
                        onClick={() => onClickItem({ item, actionType: ACTION_TYPE.EDIT })}
                    />
                    <Button
                        type='danger'
                        icon={icTrash01Red}
                        onClick={() => onClickItem({ item, actionType: ACTION_TYPE.DELETE })}
                    />
                </div>
            ),
        },
    ],
}

export const INITIAL_DATA_QUERY_DEVELOPMENT_SUMMARY_DETAIL = {
    page: 1,
    limit: 20,
    search: '',
}

export const TABLE_DEVELOPMENT_SUMMARY_IMPORT = [
    {
        name: 'Name',
        key: 'full_name',
        className: 'font-bold capitalize',
    },
    {
        name: 'NIP',
        key: 'nip',
    },
    {
        name: 'Job Title',
        key: 'job_title',
        className: 'font-bold capitalize',
    },
    {
        name: 'Department',
        key: 'department',
    },
    {
        name: 'Division',
        key: 'division',
    },
    {
        name: 'KPI',
        key: 'kpi',
        render: ({ value }) => `${value}%`,
    },
    {
        name: 'Attendance',
        key: 'attendance',
        render: ({ value }) => `${value}%`,
    },
    {
        name: 'Seminar',
        key: 'seminar',
        render: ({ value }) => `${value}%`,
    },
    {
        name: '360 Category',
        key: 'three_sixty_category',
    },
    {
        name: 'User Review',
        key: 'user_review',
    },
    {
        name: 'Performance Category',
        key: 'performance_category',
    },
    {
        name: 'Psychology Test',
        key: 'psychology_test',
    },
    {
        name: 'Potential Category',
        key: 'potential_category',
    },
    {
        name: '9 Box Label',
        key: 'nine_box_label',
    },
    {
        name: 'Status',
        key: 'status',
        width: 250,
        render: () => <Badge title='invalid' type='invalid' />,
    },
]
